module.exports = __webpack_public_path__ + "static/img/pin-no-activity-active.fdf2fde.svg";